<template>
  <div>
    <div>
      <div class="md-layout md-alignment-center">
        <md-card>
          <div style="text-align: center; margin-top: 20px">
              <md-avatar class="md-avatar-icon md-large">
                <img :src="photoUrl" v-if="photoUrl">
              </md-avatar>
            </div>
          <md-card-header style="text-align: center">
            <div class="md-title">{{name}}とめしに行く！</div>
          </md-card-header>
          <md-card-content>
            <p>twitterログインをすると、相互フォローになります。</p>
          </md-card-content>
          <div sytle="text-align: center;">
            <md-button @click="signInTwitter" class="md-raised md-primary twitter-auth-btn" style="margin-bottom: 20px">
              <md-icon>group</md-icon>
              Twitterログイン
            </md-button>
          </div>
        </md-card>
        <md-snackbar position="center" :md-active.sync="showSnackbar" md-persistent>
          <span>Twitter認証に失敗しました。</span>
        </md-snackbar>
      </div>
    </div>
  </div>
</template>

<script>
import firebaseApp from '../firebaseApp'
import firebase from 'firebase'
import router from '../router'
const provider = new firebase.auth.TwitterAuthProvider()
const db = firebaseApp.firestore()
const contactHistories = db.collection('contactHistories')
const usersRef = db.collection('users')
let data = {
  currentUser: {},
  userId: '',
  name: '',
  photoUrl: '',
  twitterUserId: '',
  showSnackbar: false
}
export default {
  name: 'EntryLogin',
  data () {
    return data
  },
  created () {
    data.currentUser = firebase.auth().currentUser
    data.userId = this.$route.params.userId
    usersRef.doc(this.$route.params.userId).get().then(querySnapShot => {
      data.name = querySnapShot.data().name
      data.photoUrl = querySnapShot.data().photoUrl
    })
  },
  methods: {
    signInTwitter: function () {
      firebase.auth().signInWithPopup(provider).then(function (result) {
        const user = result.user
        if (result.credential) {
          const usersRef = db.collection('users').doc(user.uid)
          usersRef.set({token: result.credential.accessToken, secret: result.credential.secret, name: user.displayName, photoUrl: user.photoURL}, { merge: true })
            .then(() => {
              contactHistories.add({ organizerId: data.userId, participantId: firebase.auth().currentUser.uid }).then(() => {
                router.push({ name: 'Entry', params: { userId: data.userId } })
              })
            })
        } else {
          data.showSnackbar = true
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  .md-card
    text-align: center
    width: 500px
    margin-top: 20px
    display: inline-block
    vertical-align: top
  .twitter-auth-btn
    margin-bttom: 5px
</style>



// WEBPACK FOOTER //
// src/components/EntryLogin.vue